import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import axios from 'axios';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-findcaneinstore',
  templateUrl: './findcaneinstore.component.html',
  styleUrls: ['./findcaneinstore.component.css']
})
export class FindcaneinstoreComponent implements OnInit {
  @ViewChild('table') table: ElementRef;
  Perday: UntypedFormGroup;
  constructor(private router: Router, private spinner: NgxSpinnerService) {
    this.Perday = new UntypedFormGroup({
      firstday: new UntypedFormControl('', [Validators.required]),
      lastday: new UntypedFormControl('', [Validators.required]),
      condistion: new UntypedFormControl('', [Validators.required]),
      wannafind: new UntypedFormControl('', [Validators.required]),
      groupcode: new UntypedFormControl('', [Validators.required]),
      syear: new UntypedFormControl('', [Validators.required]),
    });
  }

  ngOnInit(): void {
  }

  ExportExcel() {
    let options: any = {
      year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit"
    };
    var currentDate = new Date();
    var dateLOC = currentDate.toLocaleString('th-TH', options);

    let wannafind = this.Perday.get('wannafind').value;
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, 'สืบค้นข้อมูลการส่งอ้อย_' + dateLOC + '_' + wannafind + '.xlsx');
  }

  dataintable = [];
  sumdataintable: any[];
  newtable: any;
  Loaddatadaytoday() {
    // let data = this.Perday.value;
    let id = this.Perday.get('condistion').value;
    let wannafind = (this.Perday.get('wannafind').value).trim();
    let syear = this.Perday.get('syear').value;
    let datefirst = this.date2Local(this.Perday.get('firstday').value);
    let datelast = this.date2Local(this.Perday.get('lastday').value);
    console.log('datefirst:', datefirst, 'datelast:', datelast);
    //console.log('firstday:',this.Perday.get('firstday').value,'lastday:',this.Perday.get('lastday').value);

    let url0 = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_qcard_wgt_all_w?year_id='
      , url = '';
    if (id == 1) {
      url = url0 + syear + "&FMCODE_b1=" + wannafind + "&reportdate1=" + datefirst + "&reportdate2=" + datelast
    }
    else if (id == 2) {
      url = url0 + syear + "&REGTRUCK=" + wannafind + "&reportdate1=" + datefirst + "&reportdate2=" + datelast
    }
    else if (id == 3) {
      url = url0 + syear + "&cut_no=" + wannafind + "&reportdate1=" + datefirst + "&reportdate2=" + datelast
    }
    else if (id == 4) {
      url = url0 + syear + "&keep_no=" + wannafind + "&reportdate1=" + datefirst + "&reportdate2=" + datelast
    }
    else if (id == 5) {
      url = url0 + syear + "&groupcode=" + wannafind + "&reportdate1=" + datefirst + "&reportdate2=" + datelast
    }

    if (this.newtable != undefined || this.newtable != null) {
      this.newtable.destroy();
      this.RequeseApi(url);
    }
    else {
      this.RequeseApi(url);
    }
  }

  RequeseApi(url: string) {
    this.spinner.show()
    this.dataintable = [];
    this.sumdataintable = [];
    axios.get(url).then(res => {
      this.spinner.hide();
      if (res.data.rowsAffected[0] >= 1) {
        this.dataintable = res.data.recordset;
        this.dataintable.sort((a, b) => {
          return new Date(b.reportdate).getTime() - new Date(a.reportdate).getTime();
        });
        this.sumdataintable = [
          {
            'sumround': res.data.rowsAffected,
            'sumweight': (this.dataintable.map((el: any) => { return parseFloat(el.wgt_net) })).reduce((a, b) => a + b, 0),
            'sumccs': (this.dataintable.map((el: any) => { return parseFloat(el.ccs_value) })).reduce((a, b) => a + b, 0) / res.data.rowsAffected,
            'sumfillgas': (this.dataintable.map((el: any) => { return parseFloat(el.oil_litre) })).reduce((a, b) => a + b, 0),
            'sumsugarcaneprice': (this.dataintable.map((el: any) => { return parseFloat(el.cane_amt) })).reduce((a, b) => a + b, 0),
            'sumfillprice': (this.dataintable.map((el: any) => { return parseFloat(el.oil_amount) })).reduce((a, b) => a + b, 0)
          }
        ];
        setTimeout(() => {
          this.newtable = $(this.table.nativeElement).DataTable({
            lengthMenu: [
              [10, 25, 50, 100, 500, -1],
              [10, 25, 50, 100, 500, 'All'],
            ], order: [[0, 'desc']]
          });
        }, 300);
      }
      else { this.dataintable = [] }

    }).catch(err => { throw err });
  }

  // แปลงวันที่
  formatDate(date = '') {
    if (!date) {
      return '';
    }
    const date1 = new Date(date);
    let options: any = {
      // weekday: "short",
      year: "numeric", month: "short", day: "numeric", /*hour: "2-digit", minute  : "2-digit", timeZone: 'UTC'*/
    };
    return date1.toLocaleString('th-TH', options);
  }

  date2Local(date_i: string) {
    if (!date_i) { return ''; }
    let objectDate = new Date(date_i);
    let day = (objectDate.getDate()).toString();
    let month = (objectDate.getMonth() + 1).toString();
    let year = (objectDate.getFullYear()).toString();
    return year + "-" + month + "-" + day;
  }

  printPage() {
    window.print();
  }

}
